import PropTypes from 'prop-types';
import parse from 'url-parse';
import { withRouter } from 'next/router';
import getConfig from 'next/config';

const stripTrailingSlash = path => path.replace(/\/$/, '');

const isAbsolute = url => url.indexOf('://') > 0 || url.indexOf('//') === 0;

const join = (base, path) => {
  base = base.trim().replace(/\/$/, '');
  path = path.replace(/^\//, '');
  return `${base}/${path}`;
};

const isActive = (destination, currentPath, mount) => {
  // we send an empty object here as the baseUrl paramter to parse to prevent it using the location in the browser
  const parsedHref = parse(destination, {}).pathname;
  let parsedRouter = parse(currentPath, {}).pathname;
  if (!process.browser && mount) {
    parsedRouter = join(mount, parsedRouter);
  }
  if (
    !parsedHref.host &&
    stripTrailingSlash(parsedHref) === stripTrailingSlash(parsedRouter)
  ) {
    return true;
  }
  return false;
};

const LinkManager = ({ children, router, to }) => {
  const { publicRuntimeConfig: { mount } = {} } = getConfig() || {};

  let linkHref = to;
  if (!isAbsolute(to)) {
    // We might be passed an href which is already under our mount - we should strip it for a next Link
    linkHref = join('/', to.replace(new RegExp(`^${mount}`), ''));
  }

  return children({
    isActive: isActive(to, router.asPath, mount),
    href: to,
    linkProps: {
      href: linkHref,
      as: to,
      passHref: true,
    },
  });
};

LinkManager.propTypes = {
  to: PropTypes.string.isRequired,
};

export default withRouter(LinkManager);
